module.exports = require("core-js/library/fn/weak-set");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/weak-set.js
// module id = DwUa
// module chunks = 0